import React, { useState } from 'react';
import { LayoutTemplate, Package, ChevronRight, TrendingDown, Palette, Layers } from 'lucide-react';
import TemplateGallery from './TemplateGallery';
import { OptimizationsTab } from './Optimizations';
// import ProductTable from '../../components/ProductTable/ProductTable';
import ProductTable from '../../components/ProductTable/ProductTable';
import OutputFeed from './OutputFeed';
import { cn } from '../../utils/cn';

const Home = () => {
  const [activePage, setActivePage] = useState('templates');

  const navItems = [
    {
      id: 'templates',
      label: 'Designs',
      icon: Palette,
      component: TemplateGallery,
    },
    {
      id: 'output-feed',
      label: 'Output Feed',
      icon: Layers,
      component: OutputFeed,
    },
    {
      id: 'feed',
      label: 'Product Feed',
      icon: Package,
      component: ProductTable,
    },
    {
      id: 'optimizations',
      label: 'Optimizations',
      icon: TrendingDown, 
      component: OptimizationsTab,
    },
  ];

  const ActiveComponent = navItems.find(item => item.id === activePage)?.component;

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <aside className="w-72 bg-white border-r border-gray-200 flex flex-col shadow-sm">
        {/* Logo/Brand */}
        <div className="h-20 px-6 border-b border-gray-200 flex items-center">
          <div className="flex items-center gap-3">
            <img src="/logo compra.svg" alt="Compra" className="" />
            
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = activePage === item.id;
            
            return (
              <button
                key={item.id}
                onClick={() => setActivePage(item.id)}
                className={cn(
                  "w-full flex items-center justify-between px-4 py-3 rounded-xl transition-all duration-200 group",
                  isActive
                    ? "bg-gradient-to-r from-[#8E0DFF] to-[#2F86DC] text-white shadow-lg shadow-[#8E0DFF]/25"
                    : "text-gray-700 hover:bg-gray-100"
                )}
              >
                <div className="flex items-center gap-3">
                  <Icon 
                    className={cn(
                      "w-5 h-5 transition-transform duration-200",
                      isActive ? "scale-110" : "group-hover:scale-105"
                    )} 
                  />
                  <span className="font-medium text-sm">{item.label}</span>
                </div>
                
                {isActive && (
                  <ChevronRight className="w-4 h-4 animate-pulse" />
                )}
              </button>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="p-4 border-t border-gray-200">
          <div className="px-4 py-3 rounded-xl bg-gradient-to-br from-gray-50 to-gray-100">
            <p className="text-xs font-semibold text-gray-900 mb-1">
              Need help?
            </p>
            <p className="text-xs text-gray-600">
              Check out our documentation
            </p>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 flex flex-col overflow-hidden">
        
        {/* Page Content */}
        <div className="flex-1 overflow-hidden">
          {ActiveComponent && <ActiveComponent />}
        </div>
      </main>
    </div>
  );
};

export default Home;
